export const productState=[
    {   
        productId:1,
        productImage: 'https://static-01.daraz.pk/p/f75594efa8a2688e921629e274a043ba.jpg',
        productTitle: "New Stylish Printed hoodie",
        productPrice: '35',
        isSelected:false,
        quantity:0

    },
    {   
        productId:2,
        productImage: 'https://static-01.daraz.pk/p/d7ee8fc218b058800c1baef9d4562b92.jpg',
        productTitle: "Cotton Printed T Shirt",
        productPrice: '40',
        isSelected:false,
        quantity:0
    },
    {   
        productId:3,
        productImage: 'https://static-01.daraz.pk/p/05a377a98301bc9386059c22d33469a8.jpg',
        productTitle: "Roman Mover Official T-Shirt",
        productPrice: '60',
        isSelected:false,
        quantity:0
    },
    {   
        productId:4,
        productImage: 'https://m.media-amazon.com/images/I/61nk3CmoMfL._AC_UL320_.jpg',
        productTitle: "Damipow Dress Shirt",
        productPrice: '80',
        isSelected:false,
        quantity:0
    },
    {   
        productId:5,
        productImage: 'https://m.media-amazon.com/images/I/91oTJMbjaPL._AC_UL320_.jpg',
        productTitle: "Carter's Boys' Joggers",
        productPrice: '30',
        isSelected:false,
        quantity:0
    },
    {   
        productId:6,
        productImage: 'https://m.media-amazon.com/images/I/51dGK1Wkh2L._AC_UL320_.jpg',
        productTitle: " Boys' Baseball Pants",
        productPrice: '130',
        isSelected:false,
        quantity:0
    },
    {   
        productId:7,
        productImage: 'https://m.media-amazon.com/images/I/71ZV1YfhxNL._AC_UL320_.jpg',
        productTitle: "Boy Fleece Jogger",
        productPrice: '200',
        isSelected:false,
        quantity:0
    },
    {   
        productId:8,
        productImage: 'https://m.media-amazon.com/images/I/61pFEyF0kmL._AC_UL320_.jpg',
        productTitle: "Boys Drawstring Sweatpants",
        productPrice: '50',
        isSelected:false,
        quantity:0
    },
    {   
        productId:9,
        productImage: 'https://m.media-amazon.com/images/I/91LQqnCd6TL._AC_UX342_.jpg',
        productTitle: "Girls Shirts",
        productPrice: '30',
        isSelected:false,
        quantity:0
    },
    {
        productId:10,
        productImage: 'https://m.media-amazon.com/images/I/51Za41cossL._AC_SX385._SX._UX._SY._UY_.jpg',
        productTitle: "Kids Dress",
        productPrice: '40',
        isSelected:false,
        quantity:0
    },
    {   
        productId:11,
        productImage: 'https://m.media-amazon.com/images/I/71stfSP4lML._AC_UX522_.jpg',
        productTitle: "Men Shirts",
        productPrice: '120',
        isSelected:false,
        quantity:0
    },
    {   
        productId:12,
        productImage: 'https://m.media-amazon.com/images/I/81R+2ig8AbL._AC_UY445_.jpg',
        productTitle: 'Girls Dress',
        productPrice: '200',
        isSelected:false,
        quantity:0
    }
]